import { render, staticRenderFns } from "./ExcelKidDetailDialog.vue?vue&type=template&id=4a9d1dc4&scoped=true"
import script from "./ExcelKidDetailDialog.vue?vue&type=script&lang=js"
export * from "./ExcelKidDetailDialog.vue?vue&type=script&lang=js"
import style0 from "./ExcelKidDetailDialog.vue?vue&type=style&index=0&id=4a9d1dc4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9d1dc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a9d1dc4')) {
      api.createRecord('4a9d1dc4', component.options)
    } else {
      api.reload('4a9d1dc4', component.options)
    }
    module.hot.accept("./ExcelKidDetailDialog.vue?vue&type=template&id=4a9d1dc4&scoped=true", function () {
      api.rerender('4a9d1dc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/ByClass/ExcelTableDialog/ExcelKidDetailDialog.vue"
export default component.exports